export default class DirectorListVideoTile {
    constructor($el, offset = 0) {
        this.$el        = $el;
        this.$previews  = this.$el.querySelectorAll('video');

        if ( ! this.$previews.length) {
            return;
        }

        this.offset             = offset;
        this.$currentVideo      = null;
        this.currentVideoIndex  = 0;

        this.startFirstVideo    = this.startFirstVideo.bind(this);
        this.playNextVideo      = this.playNextVideo.bind(this);
        this.selectNewVideo     = this.selectNewVideo.bind(this);

        this.startFirstVideo();
    }

    /**
     * Start up the first video, add offset so video's change at different times on different tiles
     */
    startFirstVideo() {
        this.$currentVideo = this.$previews[0];
        this.$currentVideo.currentTime = this.offset / 1000;

        this.playNextVideo();
    }

    /**
     * Play the next video
     */
    playNextVideo() {
        this.$currentVideo.addEventListener('ended', this.selectNewVideo);

        this.$currentVideo.classList.remove('video-tile__video--hidden');
        this.$currentVideo.play();
    }

    /**
     * Select the new video after the previous one has ended and then play it
     */
    selectNewVideo() {
        this.$currentVideo.removeEventListener('ended', this.selectNewVideo);
        this.$currentVideo.currentTime = 0;

        this.currentVideoIndex += 1;
        let $newVideo = this.$previews[this.currentVideoIndex];

        if ( ! $newVideo) {
            this.currentVideoIndex = 0;
            $newVideo = this.$previews[this.currentVideoIndex];
        }

        this.$currentVideo.classList.add('video-tile__video--hidden');
        this.$currentVideo = $newVideo;

        this.playNextVideo();
    }
}